// extracted by mini-css-extract-plugin
module.exports = {"record":"QuestionAnswerWebformRecord_record__P0CbD"};